import { Quote } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { IMAGES } from "@/data/content";
import { SITE } from "@/config/site";

export const Reviews = () => (
  <section className="relative overflow-hidden bg-slate-50 py-20 sm:py-28" data-testid="reviews-section">
    <Quote size={280} className="pointer-events-none absolute -right-10 -top-10 text-emerald-100" />
    <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-sm font-bold uppercase tracking-widest text-emerald-700">Reviews</p>
        <h2 className="mt-3 font-display text-4xl font-black tracking-tight text-slate-900 sm:text-5xl">
          What Our Customers Say
        </h2>
        <div className="mx-auto mt-8 max-w-2xl rounded-3xl border border-dashed border-emerald-300 bg-white p-10">
          <p className="text-lg font-medium text-slate-600">
            Customer reviews will be displayed here as the business grows.
          </p>
          {SITE.googleReviewLink ? (
            <a href={SITE.googleReviewLink} target="_blank" rel="noreferrer" className="mt-4 inline-block font-bold text-emerald-700 underline">
              Read our Google reviews
            </a>
          ) : (
            <p className="mt-3 text-sm text-slate-400">Google reviews can be connected here once a Google Business Profile is live.</p>
          )}
        </div>
      </Reveal>
    </div>
  </section>
);

export const About = () => (
  <section id="about" className="bg-white py-20 sm:py-28" data-testid="about-section">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
      <Reveal>
        <div className="overflow-hidden rounded-[2rem] shadow-[0_20px_60px_rgba(0,0,0,0.08)]">
          <img src={IMAGES.bathroom} alt="Sparkling clean modern bathroom prepared for property inspection" className="aspect-[4/3] w-full object-cover" loading="lazy" />
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="text-sm font-bold uppercase tracking-widest text-emerald-700">About us</p>
        <h2 className="mt-3 font-display text-4xl font-black tracking-tight text-slate-900 sm:text-5xl">
          A local team you can rely on
        </h2>
        <p className="mt-5 text-lg text-slate-600">
          GoCleaning Dublin is a local property cleaning service focused on clear communication,
          reliable appointments and straightforward pricing. We help tenants, landlords and property
          managers prepare apartments and houses for handover, inspection and new occupants.
        </p>
        <p className="mt-4 text-lg text-slate-600">
          We also offer optional rubbish removal, furniture removal and moving support, allowing
          customers to arrange several move-out services through one point of contact.
        </p>
      </Reveal>
    </div>
  </section>
);
